import React, { useState, useEffect } from "react";
import { StyleSheet, ScrollView, Platform, KeyboardAvoidingView, Share, View } from "react-native";

import config from "../config/config";
// components
import Screen from "../components/Screen";
import ListItem from "../components/lists/ListItem";
import IconTouchable from "../components/IconTouchable";
import ImageCarousel from "../components/ImageCarousel";
// Hooks
import useApi from "../hooks/useApi";
import useUser from "../hooks/useUser";
import useProducts from "../hooks/useProducts";
// API
import productsApi from "../api/products";
//Navigation
import LocationPicker from "../components/pickers/LocationPicker";
import CategoryPicker from "../components/pickers/CategoryPicker";
import ListItemTextInputNew from "../components/lists/ListItemTextInputNew";
import VehiclePicker from "../components/pickers/VehiclePicker";
import { sendWhatsapp } from "../utility/contactUser";

function ProductDetailsScreen({ navigation, route }) {
    const { user } = useUser();
    const { setProductStatus } = useProducts();

    const [message, setMessage] = useState(false);

    // Products vars
    const [product, setProduct] = useState();
    const [price, setPrice] = useState();
    const [description, setDescription] = useState();

    //Product APIs
    const getProductApi = useApi(productsApi.getProduct);

    const setLocationApi = useApi(productsApi.setLocation);
    const setCategoryApi = useApi(productsApi.setCategory);
    const setVehicleApi = useApi(productsApi.setVehicle);
    const setProductPriceApi = useApi(productsApi.setPrice);
    const setProductDescriptionApi = useApi(productsApi.setDescription);
    const uploadProductImageApi = useApi(productsApi.uploadImage);
    const uploadProductImageNewApi = useApi(productsApi.uploadImageNew);
    const deleteProductImageApi = useApi(productsApi.deleteImage);

    // Gets Vehicle Details
    useEffect(() => {
        getProduct();
    }, []);

    // Sets up the state variables using the current data against the vehicle
    const getProduct = async () => {
        const response = await getProductApi.request(route.params._id);
        if (response.ok) {
            setProduct(response.data);
        } else {
            navigation.goBack();
        }
    };

    if (!product) {
        return null;
    }

    const handleShare = async () => {
        try {
            var itemToShare = {
                message:
                    "\nPrice: " +
                    product.price +
                    "\nDescription: " +
                    product.description +
                    "\nVehicle: " +
                    product.vehicle.year +
                    " " +
                    product.vehicle.make +
                    " " +
                    product.vehicle.model +
                    "\nEngine Code: " +
                    product.vehicle.engineCode +
                    "\nEngine Size: " +
                    product.vehicle.engineSize,
            };

            await Share.share(itemToShare);
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <Screen title={"Product Details"} navigation={navigation} message={message} setMessage={setMessage}>
            <KeyboardAvoidingView behavior={Platform.OS === "ios" ? "padding" : "height"} style={{ flex: 1 }}>
                <ScrollView>
                    <ImageCarousel
                        itemID={product._id}
                        imageData={product.images}
                        enableUpload={user.type == "admin"}
                        onComplete={() => getProduct()}
                        uploadApi={Platform.OS === "web" ? uploadProductImageNewApi : uploadProductImageApi}
                        deleteApi={deleteProductImageApi}
                        navigation={navigation}
                    />
                    <ListItem
                        title={"Contact Sales"}
                        utilityComponent={
                            <View style={{ flexDirection: "row" }}>
                                <IconTouchable
                                    name="phone"
                                    onPress={async () => {
                                        callNumber({ phone: "07398616294" });
                                    }}
                                    backgroundColor={config.colors.danger}
                                />
                                <IconTouchable
                                    name="whatsapp"
                                    onPress={async () => {
                                        sendWhatsapp(
                                            { phone: "07398616294" },
                                            product.description + "\nCategory: " + product.category.name
                                        );
                                    }}
                                    backgroundColor={config.colors.danger}
                                />
                            </View>
                        }
                    />
                    {user.type == "admin" && (
                        <ListItem
                            title={"Share"}
                            utilityComponent={
                                <IconTouchable
                                    name="export"
                                    onPress={handleShare}
                                    backgroundColor={config.colors.danger}
                                />
                            }
                        />
                    )}
                    <ListItemTextInputNew
                        itemID={product._id}
                        title={"Price"}
                        value={product.price ? "£" + product.price : null}
                        onChange={(text) => setPrice(text)}
                        onComplete={setProductPriceApi}
                        zeroAllowed={false}
                        numberInput={true}
                        maxLength={6}
                        editable={user.type == "admin"}
                    />
                    <ListItemTextInputNew
                        itemID={product._id}
                        title={"Description"}
                        value={product.description ? product.description : null}
                        onChange={(text) => setDescription(text)}
                        onComplete={setProductDescriptionApi}
                        editable={user.type == "admin"}
                    />
                    <LocationPicker
                        itemID={product._id}
                        value={product.location}
                        editable={user.type == "admin"}
                        onComplete={setLocationApi}
                    />
                    <CategoryPicker
                        itemID={product._id}
                        value={product.category}
                        editable={user.type == "admin"}
                        onComplete={setCategoryApi}
                    />
                    <VehiclePicker
                        itemID={product._id}
                        value={product.vehicle}
                        editable={user.type == "admin"}
                        onComplete={setVehicleApi}
                    />

                    {user.type == "admin" && product.status != "sold" && (
                        <ListItem
                            title={"Mark as Sold"}
                            utilityComponent={
                                <IconTouchable
                                    name="handshake"
                                    onPress={async () => {
                                        setProductStatus(product._id, "sold");
                                        navigation.goBack();
                                    }}
                                />
                            }
                        />
                    )}
                    {user.type == "admin" && product.status == "archive" && (
                        <ListItem
                            title={"Move to for sale"}
                            utilityComponent={
                                <IconTouchable
                                    name="store"
                                    onPress={async () => {
                                        setProductStatus(product._id, "for sale");
                                        navigation.goBack();
                                    }}
                                />
                            }
                        />
                    )}
                    {user.type == "admin" && product.status != "archive" && (
                        <ListItem
                            title={"Send to Archive"}
                            utilityComponent={
                                <IconTouchable
                                    name="delete"
                                    onPress={async () => {
                                        setProductStatus(product._id, "archive");
                                        navigation.goBack();
                                    }}
                                    backgroundColor={config.colors.red}
                                />
                            }
                        />
                    )}
                </ScrollView>
            </KeyboardAvoidingView>
        </Screen>
    );
}

const styles = StyleSheet.create({
    utility: {
        flexDirection: "row",
        alignItems: "center",
    },
    datePicker: {
        flex: 1,
    },
    buttonContainer: {
        position: "relative",
        top: 20,
    },
    container: {
        padding: 20,
        paddingTop: 30,
        backgroundColor: config.colors.white,
    },
    text: {
        color: config.colors.white,
        fontWeight: "bold",
        fontSize: 17,
    },
    titleInput: {
        alignItems: "center",
        width: "100%",
    },
    middleLine: {
        flexDirection: "row",
        justifyContent: "space-between",
    },
    bottomLine: {
        flexDirection: "row",
        justifyContent: "space-between",
    },
    bottomContainer: {
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
    },
    textInput: {
        borderRadius: 10,
        padding: 10,
        textAlignVertical: "top",
        flexDirection: "row",
    },
    contactBox: {
        flexDirection: "row",
    },
    totalsContainer: {
        justifyContent: "space-evenly",
        paddingTop: 10,
        backgroundColor: config.colors.white,
        flexDirection: "column",
        alignItems: "center",
    },
});

export default ProductDetailsScreen;
